import { Directive, ElementRef, HostListener } from '@angular/core';

@Directive({
  selector: '[coreCommaToDot]',
})
export class CommaToDotDirective {
  constructor(private readonly el: ElementRef) {}

  @HostListener('keydown', ['$event'])
  public onKeyDown(event: KeyboardEvent) {
    console.log(this.el.nativeElement.value);
    // Allow Backspace, tab, end, and home keys
    if (event.key === ',') {
      event.preventDefault();
      if (!(this.el.nativeElement as HTMLInputElement).value.includes('.')) {
        (this.el.nativeElement as HTMLInputElement).value = (this.el.nativeElement as HTMLInputElement).value.concat(
          '.'
        );
      }
    }
  }
}
